import assetsIcon from "./icons/assets.png";
import workIcon from "./icons/work.png";
import tasksIcon from "./icons/tasks.png";
import drawsIcon from "./icons/draws.png";
import styles from "./Menu.module.scss";
import { AppContext } from "./app-context";
import { IMenuButton, MenuButton } from "./MenuButton";
import { ActionPromptType } from "../../hooks/prompts";
import { useEffect } from "react";
import { useDispatch } from "../../hooks";
import { setAppContext } from "../../redux/app.slice";
import { useLocation } from "react-router-dom";

export { AppContext } from "./app-context";

const menuData: IMenuButton[] = [
    { caption: "Офис", icon: workIcon, context: AppContext.Office, promptType: ActionPromptType.OFFICE_ADD },
    { caption: "Заработок", icon: tasksIcon, context: AppContext.Actions, promptType: ActionPromptType.TASKS_ADD },
    { caption: "Подарки", icon: drawsIcon, context: AppContext.Draw, promptType: ActionPromptType.DRAWS_ADD },
    { caption: "Активы", icon: assetsIcon, context: AppContext.Assets},
];

export const Menu = () => {
    const location = useLocation();
    const dispatch = useDispatch();

    useEffect(() => {
        const newContext = location.pathname.split('/')?.[1] as AppContext;
        dispatch(setAppContext(newContext));
    }, [location.pathname, dispatch]);

    return (
        <div className={styles.menu}>
            { menuData.map(button => (                
                <MenuButton
                    key={ button.context }
                    { ...button }
                />
            )) }        
        </div>
    );
};
